import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=cd6cbb9e&scoped=true"
import script from "./factory.vue?vue&type=script&lang=js"
export * from "./factory.vue?vue&type=script&lang=js"
import style0 from "./factory.vue?vue&type=style&index=0&id=cd6cbb9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6cbb9e",
  null
  
)

export default component.exports